import api from '@/api';
import router from '@/router';

export default {

  state : {},

  mutations : {},

  actions : {
    createFreeRegistration ({ commit, dispatch }, datas) {
      dispatch(`isLoading`);
      return api.post(`free-registrations`, datas);
    },
    validateEmailForRegistration (noop, registrationId) {
      return api.post(`free-registrations/${registrationId}/validate-email`);
    },
    setPassword (noop, params) {
      return api.post(`free-registrations/${params.registrationId}/set-password`, {
        password : params.password,
      });
    },
    successCheckEmails ({ dispatch }) {
      dispatch(`isLoading`, false);
      router.push({ name : `RegistrationSuccess` });
    },
    successPassword (noop, { jwt, registrationId }) {
      localStorage.setItem(`jwt`, jwt.token);
      localStorage.setItem(`jwt.expiration`, jwt.expiration);
      document.location.href = `/registrations/${registrationId}/home`;
    },
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/registration.js